<template>
  <moe-page>
    <moe-top ref="moeTop" @changeCourseCommonSearch="changeCourseCommonSearch"></moe-top>
    <div class="top_box flex Flexjustify Flexalign flexcolumn">
      <div class="top_filter_box flex Flexjustify Flexalign flexcolumn">
        <!-- <div class="filter_box" v-for="(item, index) in filterList" :key="index">
          <div class="flex FlexBetween">
            <div class="flex">
              <div>{{ item.name }}:</div>
              <div v-for="(sitem, sindex) in item.list" :key="sindex" class="area_info">
                {{ sitem.label }}
              </div>
            </div>
            <div class="filter flex Flexalign FlexEvenly" v-if="item.showMore">
              <el-image class="filter_icon" :src="imgPath('filter_icon.png')"></el-image>
              <div>更多</div>
              <el-image class="filter_icon" :src="imgPath('arrow_up.png')"></el-image>
            </div>
          </div>
          <div v-if="item.subList" class="sublist_box flex">
            <div class="opacity_box">{{ item.name }}:</div>
            <div class="flex-1 flex area_box FlexBetween">
              <div class="flex">
                <div class="area_info" v-for="(ssitem, ssindex) in item.subList" :key="ssindex">
                  {{ ssitem.label }}
                </div>
              </div>
              <div class="flex more_box Flexalign">
                <div>更多</div>
                <el-image class="filter_icon" :src="imgPath('arrow_up.png')"></el-image>
              </div>
            </div>
          </div>
        </div> -->
        <div class="filter_box flex">
          <div>学段:</div>
          <div class="flex FlexWrap flex-1">
            <div class="area_info cursor_pointer" :class="[selectedInfo.stageId == '' ? 'active_area_info' : '']"
              @click="selectStage('')">
              不限
            </div>
            <div v-for="(item, index) in stageList" :key="index" class="area_info cursor_pointer"
              :class="[selectedInfo.stageId == item.stageId ? 'active_area_info' : '']"
              @click="selectStage(item.stageId)">
              {{ item.stageName }}
            </div>
          </div>
        </div>
        <div class="filter_box flex">
          <div>学科:</div>
          <div class="flex FlexWrap flex-1">
            <div class="area_info cursor_pointer" :class="[selectedInfo.subjectId == '' ? 'active_area_info' : '']"
              @click="selectSubjet('')">
              不限
            </div>
            <div v-for="(item, index) in subjectList" :key="index" class="area_info cursor_pointer" :class="[
              selectedInfo.subjectId == item.subjectId ? 'active_area_info' : '',
            ]" @click="selectSubjet(item.subjectId)">
              {{ item.subjectName }}
            </div>
          </div>
        </div>
        <div class="filter_box flex">
          <div>版本:</div>
          <div class="flex FlexWrap flex-1">
            <div class="area_info cursor_pointer" :class="[selectedInfo.publisherId == '' ? 'active_area_info' : '']"
              @click="selectPublisher('')">
              不限
            </div>
            <div v-for="(item, index) in publisherList" :key="index" class="area_info cursor_pointer" :class="[
              selectedInfo.publisherId == item.publisherId ? 'active_area_info' : '',
            ]" @click="selectPublisher(item.publisherId)">
              {{ item.publisherName }}
            </div>
          </div>
        </div>
        <div class="filter_box flex">
          <div>学册:</div>
          <div class="flex FlexWrap flex-1">
            <div class="area_info cursor_pointer" :class="[selectedInfo.termId == '' ? 'active_area_info' : '']"
              @click="selectTerm('')">
              不限
            </div>
            <div v-for="(item, index) in termList" :key="index" class="area_info cursor_pointer"
              :class="[selectedInfo.termId == item.termId ? 'active_area_info' : '']" @click="selectTerm(item.termId)">
              {{ item.termName }}
            </div>
          </div>
        </div>
        <div class="filter_box flex">
          <div>难度:</div>
          <div class="flex FlexWrap flex-1">
            <div class="area_info cursor_pointer"
              :class="[selectedInfo.courseDifficulty == '' ? 'active_area_info' : '']" @click="selectDifficulty('')">
              不限
            </div>
            <div v-for="(item, index) in difficultyList" :key="index" class="area_info cursor_pointer" :class="[
              selectedInfo.courseDifficulty == item.difficultyId
                ? 'active_area_info'
                : '',
            ]" @click="selectDifficulty(item.difficultyId)">
              {{ item.difficultyName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box flex Flexjustify Flexalign">
      <div class="content flex">
        <div class="content_left">
          <div class="course_list_box search_list_box">
            <div class="list_filter flex Flexalign FlexBetween">
              <div class="text_active">课程({{ listTotal }})</div>
              <div class="flex Flexalign list_filter_content">
                <div class="cursor_pointer" :class="[selectedInfo.orderByColumn == '' ? 'text_active' : '']"
                  @click="changeSort('')">最新课程</div>
                <div class="cursor_pointer mar_left_30"
                  :class="[selectedInfo.orderByColumn == 'order' ? 'text_active' : '']" @click="changeSort('order')">最多购买
                </div>
                <div class="cursor_pointer mar_left_30 flex Flexalign"
                  :class="[selectedInfo.orderByColumn == 'price' ? 'text_active' : '']" @click="changeSort('price')">
                  价格
                  <div class="flex Flexalign flexcolumn mar_left_10 sort_box">
                    <el-icon>
                      <CaretTop />
                    </el-icon>
                    <el-icon>
                      <CaretBottom />
                    </el-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="search_list" v-if="searchList.length">
              <div class="search_course_one flex Flexalign FlexBetween cursor_pointer"
                v-for="(item, index) in searchList" :key="index" @click="goCourseDetail(item)" @mouseenter="showHighColor(item)"
                @mouseleave="hideHighColor">
                <div>
                  <el-image class="course_one_img" :src="imgPath(item.courseCoverImg)"></el-image>
                </div>
                <div class="flex-1 mar_left_20 list_one_content flex FlexBetween Flexalign flexcolumn">
                  <div class="flex Flexalign FlexBetween width_100">
                    <div class="course_title toverflow course_one_title" :class="[selectedCourse==item.courseId?'high_notice_color':'']">{{ item.courseName }}</div>
                    <div class="course_rate">
                      <el-rate v-model="item.rate" disabled show-score text-color="#666666" score-template="{value}分" />
                    </div>
                  </div>
                  <div class="flex Flexalign width_100">
                    <div class="course_title">
                      <el-image class="institutionIcon" :src="imgPath(item.shopLogo)"></el-image>
                    </div>
                    <div class="mar_left_10 institutionName">
                      {{ item.shopName }}
                    </div>
                  </div>
                  <div class="institutionIntroduce toverflows toverflow2">
                    {{ item.shopBrief }}
                  </div>
                  <div class="institutionIntroduce flex Flexalign FlexBetween width_100">
                    <div>{{ item.chapterCountResult?.chapterNum || 0 }}课时 · {{ item.courseExtra.userNum }}人学习</div>
                    <div class="course_price">
                      <span class="course_price_unit" v-if="item.saleMethod == 2">￥</span>{{ (item.saleMethod == 2) ? item.coursePrice : '免费' }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pagination_box mar_top_20 flex FlexjustifyEnd" v-if="listTotal > selectedInfo.pageSize">
                <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]"
                  :total="listTotal" v-model:page-size="selectedInfo.pageSize" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" />
              </div>
            </div>
            <div v-else>
              <moe-empty url="moe_empty_bg_img.png" emptyText="暂无课程"></moe-empty>
            </div>
          </div>
          <div class="course_list_box">
            <div class="flex FlexBetween">
              <div class="recommend">推荐课程</div>
              <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goCourseList">
                更多
                <div class="flex Flexalign" style="margin-left: 5px">
                  <el-icon :size="18">
                    <ArrowRight color="rgba(102, 102, 102, 1)" />
                  </el-icon>
                </div>
              </div>
            </div>
            <courseList></courseList>
          </div>
        </div>
        <div class="content_right">
          <recommendCourseList></recommendCourseList>
        </div>
      </div>
    </div>
    <moe-bottom></moe-bottom>
    <moe-right></moe-right>
  </moe-page>
</template>
<script>
import { mapState } from "vuex";
import courseList from "./components/courseList.vue";
import recommendCourseList from "./components/recommendCourseList.vue";
export default {
  name: "GjkcH5Index",
  components: {
    courseList,
    recommendCourseList,
  },
  computed: {
    ...mapState({
      stageList: (state) => state.filter.stageList,
      subjectList: (state) => state.filter.subjectList,
      publisherList: (state) => state.filter.publisherList,
      termList: (state) => state.filter.termList,
      difficultyList: (state) => state.filter.difficultyList,
      userInfo: (state) => state.userInfo,
      selectCourseType: (state) => state.user.selectCourseType,
    }),
  },
  watch: {
    selectedInfo: {
      handler(value) {
        console.log(value);
        this.getCourseList();
      },
      deep: true
    },
    selectCourseType: {
      handler(value) {
        this.selectedInfo.typeId = value;
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      selectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 10, // 单页数量
        commonSearch: '',  // 搜索字段
        orderByColumn: '', // 排序字段
        isAsc: 'desc', //升降序
        typeId: '',  // 课程类型
      },
      filterList: [
        {
          name: "地区",
          list: [
            { label: "不限", value: "0" },
            { label: "江宁", value: "1" },
            { label: "浦口", value: "0" },
            { label: "栖霞", value: "0" },
            { label: "鼓楼", value: "0" },
            { label: "秦淮", value: "0" },
            { label: "雨花台", value: "0" },
            { label: "六合", value: "0" },
            { label: "建邺", value: "0" },
            { label: "玄武", value: "0" },
            { label: "溧水", value: "0" },
            { label: "滨江开发区", value: "0" },
            { label: "高淳", value: "0" },
          ],
          subList: [
            { label: "不限", value: "0" },
            { label: "江宁", value: "1" },
            { label: "浦口", value: "0" },
            { label: "栖霞", value: "0" },
            { label: "鼓楼", value: "0" },
            { label: "秦淮", value: "0" },
            { label: "雨花台", value: "0" },
          ],
          showMore: true,
          showFilter: true,
        },
      ],
      searchList: [],
      searchValue: '',
      listTotal: '',
      selectedCourse:'',
    };
  },

  mounted() {
    let selectedParams = this.$Jump.getUrlParams(window.location.hash.split("?")[1])
      .selectedParams;
    if (selectedParams) {
      this.selectedInfo = JSON.parse(selectedParams);
    }
    this.searchValue = this.$Jump.getUrlParams(window.location.hash.split("?")[1])
      .searchValue;
    this.$refs.moeTop.courseName = this.searchValue;
    this.selectedInfo.commonSearch = this.$refs.moeTop.courseName;
    this.getCourseList();
  },

  methods: {
    showHighColor(info) {
      this.selectedCourse= info.courseId;
    },
    hideHighColor() {
      this.selectedCourse = "";
    },
    // 排序
    changeSort(type) {
      // 价格排序时最好只筛选收费课程（处理时价格加上升序降序，其他默认降序）
      if (type == 'price') {
        this.selectedInfo.saleMethod == 2;
        this.selectedInfo.isAsc = (this.selectedInfo.isAsc == "desc" ? 'asc' : 'desc')
      } else {
        this.selectedInfo.saleMethod == '';
        this.selectedInfo.isAsc = "desc";
      }
      this.selectedInfo.orderByColumn = type;
    },
    handleSizeChange() {
      this.getCourseList();
    },
    handleCurrentChange(value) {
      this.selectedInfo.page = value;
      this.getCourseList();
    },
    // 选择学段
    selectStage(value) {
      this.selectedInfo.stageId = value;
    },
    // 选择学科
    selectSubjet(value) {
      this.selectedInfo.subjectId = value;
    },
    // 选择版本
    selectPublisher(value) {
      this.selectedInfo.publisherId = value;
    },
    // 选择学册
    selectTerm(value) {
      this.selectedInfo.termId = value;
    },
    // 难度选择
    selectDifficulty(value) {
      this.selectedInfo.courseDifficulty = value;
    },
    changeStage(info) {
      this.stageValue = info.value;
    },
    changeCourseCommonSearch() {
      if (this.$refs.moeTop.courseName.length >= 100) {
        this.$Dialog.toast("输入内容过长", { type: 'warning' });
        return
      }
      this.selectedInfo.commonSearch = this.$refs.moeTop.courseName;
    },
    getCourseList() {
      this.$Api.course
        .getCourseList(this.selectedInfo)
        .then((res) => {
          this.searchList = res.data.data.list;
          this.searchList.forEach((item) => {
            item.rate = this.$Tools.scoreToStar(item.courseExtra.appraiseScore);
          });
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    // 课程列表页
    goCourseList() {
      this.$Jump.href("/courseList", {
        selectedParams: JSON.stringify(this.selectedInfo),
      });
    },
    // 详情
    goCourseDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  width: 140px;
  height: 36px;
  background: linear-gradient(90deg, #00d5c2, #00d498);
  border-radius: 18px;
  color: #fff;
  line-height: 36px;
  text-align: center;
}

.top_box {
  width: 100%;
  background: #f3f3f3;
  padding-top: 20px;

  .top_filter_box {
    width: $pageMainWidth;
    padding: 30px 20px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
  }

  .filter_box {
    width: 100%;
    line-height: 32px;
    margin-bottom: 10px;

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
    }

    .active_area_info {
      color: #13d6aa;
    }

    .filter {
      width: 95px;
      height: 32px;
      border-radius: 5px;
      border: 1px solid #e1e1e1;
      line-height: 32px;

      .filter_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .sublist_box {
    margin-top: 10px;

    .opacity_box {
      opacity: 0;
    }

    .area_box {
      margin-left: 10px;
      height: 45px;
      //   background: #f3f3f3;
      border-radius: 10px;
    }

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
      //   line-height: 45px;
    }

    .more_box {
      height: 45px;
      margin-right: 10px;
    }

    .filter_icon {
      width: 18px;
      height: 18px;
    }
  }
}

.content_box {
  padding-top: 15px;
  width: 100%;
  background: #f3f3f3;

  .content {
    width: $pageMainWidth;

    .content_left {
      .search_list_box {
        .list_filter {
          .list_filter_content {
            color: #999999;

            .sort_box {
              :deep(.el-icon) {
                height: 8px;
              }
            }
          }
        }

        .search_list {
          .search_course_one {
            padding: 25px 0;
            border-bottom: 1px solid rgba(20, 20, 20, 0.1);

            .course_one_img {
              width: 260px;
              height: 150px;
              border-radius: 10px;
            }

            .list_one_content {
              height: 150px;

              .width_100 {
                width: 100%;

                .course_title {
                  font-size: 20px;
                  color: #333333;
                  font-weight: 600;
                }
                .high_notice_color{
                  color: #13d6aa;
                }

                .course_one_title {
                  width: 300px;
                }

                .institutionIcon {
                  width: 24px;
                  height: 24px;
                  background: #242324;
                  border-radius: 50%;
                }

                .institutionName {
                  color: #333333;
                }

                .course_price {
                  color: #ff6619;
                  font-size: 18px;
                  font-weight: 600;

                  .course_price_unit {
                    font-size: 16px;
                    font-weight: 400;
                  }
                }
              }

              .institutionIntroduce {
                width: 100%;
                color: #999999;
                line-height: 24px;
              }
            }
          }
        }
      }

      .course_list_box {
        margin: 20px 0;
        width: 848px;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;

        .recommend {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .more_btn {
          color: rgba(102, 102, 102, 1);
        }
      }

      .advertisement_box {
        margin-bottom: 40px;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;

        // .advertisement_one{
        //     width: 45%;
        // }
        .advertisement_img {
          width: 390px;
          height: 150px;
        }
      }
    }

    .content_right {
      margin-left: 20px;
      width: calc($pageMainWidth - 868px);
    }
  }
}

.pagination_box {
  width: 100%;
}
</style>
